import type { ApiContext } from "@/api/types";
import { httpFeatureFlag } from "@/api/featureFlag";

export const featureFlagRequests = {
  get_all_targetted_feature_flags: function ({
    data,
  }: {
    context?: ApiContext;
    data?: { flag_set: string };
  } = {}) {
    return httpFeatureFlag
      .post("/v1/feature_flag/private", {
        headers: { Authorization: localStorage.getItem("token") ?? "" },
        json: data,
      })
      .json<unknown>();
  },

  get_feature_flag: function ({
    searchParams,
  }: {
    context?: ApiContext;
    searchParams: { feature_name: string };
  }) {
    return httpFeatureFlag.get("/v1/public/feature_flag", { searchParams }).json<unknown>();
  },

  get_feature_flag_set: function ({
    data,
  }: {
    context?: ApiContext;
    data?: { flag_set: string };
  } = {}) {
    return httpFeatureFlag
      .post("/v1/feature_flag/public", {
        json: data,
      })
      .json<unknown>();
  },

  post_feature_flag_error: function ({
    data,
  }: {
    context?: ApiContext;
    data?: unknown;
  } = {}) {
    return httpFeatureFlag
      .post("/v1/feature_flag/error", {
        headers: { Authorization: localStorage.getItem("token") ?? "" },
        json: data,
      })
      .json<unknown>();
  },
};
